import { useMemo } from 'react';

import { useAutoRefresh } from '../../hooks/useAutoRefresh';
import { generateWorkshopStatus } from '../../utils/groupUtils';
import { SECOND } from '../../utils/timeUtils';
import { useDeepCompareMemoize } from '../../utils/useDeepMemp';

export const WORKSHOP_STATUS_REFRESH_MS = SECOND * 10;

export function useRefreshedWorkshop(workshop, { showLive, statusOptions } = {}) {
  const now = useAutoRefresh(WORKSHOP_STATUS_REFRESH_MS);
  const options = useDeepCompareMemoize({ showLive, ...statusOptions });

  return useMemo(() => generateWorkshopStatus([workshop], options)[0] ?? workshop, [
    workshop,
    options,
    now,
  ]);
}
